import {
	AccommodationIcon,
	BakeryIcon,
	BarIcon,
	BeachIcon,
	BoatIcon,
	BusIcon,
	BusinessIcon,
	CafeIcon,
	CarIcon,
	ComedyIcon,
	CommuteIcon,
	CultureIcon,
	CyclingIcon,
	DessertIcon,
	EducationIcon,
	EntertainmentIcon,
	FlightIcon,
	GameIcon,
	GardenIcon,
	GolfIcon,
	GovernmentIcon,
	GymIcon,
	HaircutIcon,
	HealthIcon,
	HikingIcon,
	HouseIcon,
	LandmarkIcon,
	LocationIcon,
	MusicIcon,
	ParkIcon,
	PetIcon,
	RestaurantIcon,
	RestroomIcon,
	SailingIcon,
	ServicesIcon,
	ShoppingBagIcon,
	SkiIcon,
	SpaIcon,
	SportsIcon,
	SubwayIcon,
	SwimmingIcon,
	WorshipIcon,
} from '@/assets/icons'
import { PlaceIcon, placeIconOf } from '@lib/placeTypes'
import type { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

/** Each place icon's glyph — the web's stand-ins for the iOS place icons, a Material glyph for each Material Symbol. */
const GLYPHS: Record<PlaceIcon, React.ElementType<SvgIconProps>> = {
	airport: FlightIcon,
	bakery: BakeryIcon,
	beer: BarIcon,
	boat: BoatIcon,
	bus: BusIcon,
	cafe: CafeIcon,
	comedy: ComedyIcon,
	cycling: CyclingIcon,
	dessert: DessertIcon,
	// iOS draws fishing with a sailing boat.
	fishing: SailingIcon,
	game: GameIcon,
	garden: GardenIcon,
	golf: GolfIcon,
	gym: GymIcon,
	haircut: HaircutIcon,
	hiking: HikingIcon,
	music: MusicIcon,
	park: ParkIcon,
	pet: PetIcon,
	ski: SkiIcon,
	spa: SpaIcon,
	subway: SubwayIcon,
	swimming: SwimmingIcon,
	automotive: CarIcon,
	business: BusinessIcon,
	culture: CultureIcon,
	education: EducationIcon,
	entertainment: EntertainmentIcon,
	facilities: RestroomIcon,
	finance: LandmarkIcon,
	food: RestaurantIcon,
	geoArea: LocationIcon,
	government: GovernmentIcon,
	health: HealthIcon,
	housing: HouseIcon,
	lodging: AccommodationIcon,
	naturalFeatures: BeachIcon,
	services: ServicesIcon,
	shopping: ShoppingBagIcon,
	sports: SportsIcon,
	transportation: CommuteIcon,
	// iOS draws a candle; Material has no candle, and no church, temple or mosque speaks for all of them.
	worship: WorshipIcon,
}

interface PlaceTypeIconProps extends SvgIconProps {
	/** The place's Google types; none, as a typed-in place has, draws the pin. */
	types: readonly string[] | null | undefined
}

/** A place drawn as iOS draws it in the place search: by what its Google types say it is. */
const PlaceTypeIcon: React.FC<PlaceTypeIconProps> = ({ types, ...props }) => {
	const icon = placeIconOf(types)
	const Glyph = GLYPHS[icon]
	return <Glyph aria-hidden data-place-icon={icon} {...props} />
}

export default PlaceTypeIcon
